import React, { useEffect, useState } from 'react';

import './category.scss';

const Category = ({ badge }) => {
  const [category, setCategory] = useState('');

  useEffect(() => {
    const categories = {
      client: '<span style="background: #6B2D60">Clientes</span>',
      sellers: '<span style="background: #C73C53">Vendedores</span>',
      fraud: '<span style="background: #3E2566">Tipos de fraude</span>',
    };

    setCategory(categories[badge]);
  }, [badge]);

  return <div className="card-badge" dangerouslySetInnerHTML={{ __html: category }} />;
};

export default Category;
